<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">

			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ $t('employees.list.title') }}</h4>
					<p class="mb-0">{{ $t('employees.list.description') }}</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<router-link to="/employees/create">
						<button type="submit" class="btn btn-primary">{{ $t('employees.list.createButton') }}</button>
					</router-link>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card">
					<div class="card h-100">
						<div class="card-body pb-0">
							<form class="dt_adv_search">
								<div class="row">
									<div class="col-12">
										<div class="row g-5">
											<div class="col-12 col-sm-12 col-lg-12">
												<div class="form-floating form-floating-outline">
													<input
														type="text"
														class="form-control dt-input dt-full-name"
														data-column="1"
														placeholder="Phillipe Porte"
														data-column-index="0"
														v-model="search"
														@input="applyFilters"
														autocomplete="off"
													/>
													<label>{{ $t('employees.list.searchPlaceholder') }}</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
						<div class="table-responsive">
							<table class="table table-borderless">
								<thead>
									<tr class="border-bottom">
										<th class="bg-transparent fs-xsmall">#</th>
										<th class="bg-transparent fs-xsmall">{{ $t('employees.list.name') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('employees.list.email') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('employees.list.company') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('employees.list.role') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('employees.list.trainingsCount') }}</th>
										<th class="bg-transparent fs-xsmall text-center">{{ $t('employees.list.ssnHeader') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('common.fields.actions') }}</th>
									</tr>
								</thead>
								<tbody class="table-border-bottom-0">
									<tr v-for="(employee, index) in employees" :key="index">
										<td>
											<div class="avatar avatar">
												<span class="avatar-initial rounded-circle bg-label-primary">{{ generateInitials(employee) }}
												</span>
											</div>
										</td>
										<td>
											<span class="fw-medium">{{ employee.firstName }} {{ employee.lastName }}</span>
										</td>
										<td>
											<span class="fw-medium">{{ employee.email }} </span>
										</td>
										<td>
											<p class="fw-medium text-truncate" v-if="employee.agency">
												{{ employee.agency.toUpperCase() }}
											</p>
											<p class="fw-medium text-truncate" v-else>
												{{ employee.company.name }}
											</p>
										</td>
										<td>
											<span class="badge rounded-pill bg-label-danger me-1" v-if="employee.role === 'manager' && !employee.isSubCompany">
												{{ $t('common.roles.manager') }}
											</span>
											<span class="badge rounded-pill bg-label-danger me-1" v-else-if="employee.role === 'manager' && employee.isSubCompany">
												{{ $t('common.roles.managerSubsidiary') }}
											</span>
											<span class="badge rounded-pill bg-label-danger me-1" v-else-if="employee.role === 'consultant'">
												{{ $t('common.roles.consultant') }}
											</span>
											<span class="badge rounded-pill bg-label-primary me-1" v-else>
												{{ $t('common.roles.trainee') }}
											</span>
										</td>
										<td>
											<span class="badge rounded-pill bg-label-primary me-1" v-if="employee.trainings > 0">
												{{ employee.trainings }}
											</span>
											<span class="badge rounded-pill bg-label-secondary me-1" v-else>
												{{ employee.trainings }}
											</span>
										</td>
										<td class="text-center">
											<i v-if="employee.socialSecurityNumber" class="ri-checkbox-circle-fill text-success ri-20px"
												data-bs-toggle="tooltip" :data-bs-title="$t('employees.list.ssnFilled')"></i>
											<i v-else class="ri-error-warning-line text-warning ri-20px"
												data-bs-toggle="tooltip" :data-bs-title="$t('employees.list.ssnMissing')"></i>
										</td>
										<td>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" data-bs-toggle="tooltip" :data-bs-title="$t('employees.list.viewProfile')" @click="goToProfile(employee._id)">
												<i class="ri-user-line ri-22px"></i>
											</a>

											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" data-bs-toggle="tooltip" :data-bs-title="$t('employees.list.editProfile')" @click="showEditUserModal(employee)">
												<i class="ri-pencil-line ri-22px"></i>
											</a>

											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="deleteEmployee(employee._id)" v-if="employee.trainings === 0" data-bs-toggle="tooltip" :data-bs-title="$t('employees.list.deleteTooltip')">
												<i class="ri-delete-bin-6-line ri-22px"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row mt-5" v-if="pagination.totalEntries > 5">
							<div class="col-sm-12 col-md-6">
								<div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite" style="padding-left: 15px;margin: 10px;">
									{{ $t('employees.list.totalEmployees', { count: pagination.totalEntries }) }}
								</div>
							</div>
							<div class="col-sm-12 col-md-6 d-flex justify-content-end" style="padding-right: 40px;">
								<div class="pagination-container">
									<ul class="pagination">
										<!-- Bouton Précédent -->
										<li :class="['page-item', { disabled: pagination.page === 1 }]" @click="changePage(pagination.page - 1)">
											<a class="page-link">
												<i class="ri-arrow-left-s-line"></i>
											</a>
										</li>

										<!-- Pages dynamiques (affichage par groupe de 3) -->
										<li v-for="page in visiblePages" :key="page" :class="['page-item', { active: page === pagination.page }]" @click="changePage(page)">
											<a class="page-link">{{ page }}</a>
										</li>

										<!-- Bouton Suivant -->
										<li :class="['page-item', { disabled: pagination.page + 3 > pagination.totalPages }]" @click="changePage(pagination.page + 1)">
											<a class="page-link">
												<i class="ri-arrow-right-s-line"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->

		<!-- EDIT USER -->
		<div class="modal fade" id="editUser" tabindex="-1" aria-hidden="true" v-if="selectedEmployee">
			<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
				<div class="modal-content">
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

					<div class="text-center" v-if="selectedEmployeeUpdated">
						<CheckIcon />
						<p class="text-muted mt-5 small">
							{{ $t('employees.edit.updateSuccess') }}
						</p>
					</div>

					<div class="modal-body p-0" v-if="!selectedEmployeeUpdated">
						<div class="text-center mb-6">
							<h4 class="mb-2">{{ $t('employees.edit.title', { firstName: selectedEmployee.firstName, lastName: selectedEmployee.lastName }) }}</h4>
							<p class="text-muted mb-0 small">
								{{ $t('employees.edit.subtitle') }}<br />({{ $t('employees.edit.subtitleHint') }})
							</p>
						</div>

						<form id="editUserForm" class="row g-5" onsubmit="return false">
							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										id="modalEditUserFirstName"
										name="modalEditUserFirstName"
										class="form-control"
										value="Prenom"
										autocomplete="off"
										v-model="selectedEmployee.firstName" />
									<label for="modalEditUserFirstName">{{ $t('common.fields.firstName') }}</label>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										id="modalEditUserLastName"
										name="modalEditUserLastName"
										class="form-control"
										value="Nom"
										autocomplete="off"
										v-model="selectedEmployee.lastName" />
									<label for="modalEditUserLastName">{{ $t('common.fields.lastNameUpper') }}</label>
								</div>
							</div>

							<div class="col-12">
								<div class="form-floating form-floating-outline">
									<input
										type="email"
										id="modalEditUserFirstName"
										name="modalEditUserFirstName"
										class="form-control"
										value="alexandre@pika.com"
										autocomplete="off"
										v-model="selectedEmployee.email" />
									<label for="modalEditUserFirstName">{{ $t('common.fields.email') }}</label>
								</div>
							</div>

							<div class="col-12" v-if="displayEntityName">
								<div class="form-floating form-floating-outline">
									<input
										type="text"
										id="modalEditUserEntityName"
										name="modalEditUserEntityName"
										class="form-control"
										:placeholder="$t('employees.edit.entityNamePlaceholder')"
										autocomplete="off"
										v-model="selectedEmployee.entityName" />
									<label for="modalEditUserEntityName">{{ $t('common.fields.entityName') }}</label>
								</div>
							</div>

							<div class="col-12">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserSocialSecurityNumber"
											name="modalEditUserSocialSecurityNumber"
											class="form-control"
											placeholder="1 85 05 78 006 084 36"
											autocomplete="off"
											@input="handleSsnInput"
											v-model="selectedEmployee.socialSecurityNumber" />
										<label for="modalEditUserSocialSecurityNumber">{{ $t('common.fields.socialSecurityNumber') }}</label>
										<small v-if="ssnError" class="text-danger">{{ ssnError }}</small>
									</div>
									<span class="input-group-text" data-bs-toggle="tooltip" :data-bs-title="$t('employees.ssnInfo')">
										<i class="ri-information-line"></i>
									</span>
								</div>
							</div>

							<div class="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
								<button type="submit" class="btn btn-primary" @click="saveEmployeeProfile()">
									{{ $t('common.actions.save') }}
								</button>
								<button
									type="reset"
									class="btn btn-outline-secondary btn-reset"
									data-bs-dismiss="modal"
									aria-label="Close"
									@click="selectedEmployee = null"
								>
									{{ $t('common.actions.cancel') }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import CheckIcon from "@/components/CheckIcon";

import { Tooltip } from 'bootstrap'
import { formatNIR, isValidNIR, normalizeNIR } from "@/helpers/nir";

export default {
	name: "EmployeeList",

	components: { CheckIcon },

	data() {
		return {
			selectedEmployee: null,
			selectedEmployeeUpdated: false,
			ssnError: null,
			displayEntityName: false,
			employees: [],
			search: null,
			pagination: {
				page: 1,
				limit: 10, // Nombre d'éléments par page
				totalEntries: 0,
				totalPages: Math.ceil(99 / 10) // Calculé dynamiquement
			}
		};
	},

	computed: {
		visiblePages() {
			const start = Math.floor((this.pagination.page - 1) / 3) * 3 + 1;
			const end = Math.min(start + 2, this.pagination.totalPages);
			return Array.from({ length: end - start + 1 }, (_, i) => start + i);
		},
		// Calcul du premier élément affiché
		startEntry() {
			return (this.pagination.page - 1) * this.pagination.limit + 1;
		},
		// Calcul du dernier élément affiché
		endEntry() {
			return Math.min(this.pagination.page * this.pagination.limit, this.pagination.totalEntries);
		}
	},

	methods: {
		goToProfile(employeeId) {
			this.$router.push(`/employees/profile/${employeeId}`);
		},

		handleSsnInput(event) {
			if (this.selectedEmployee)
				this.selectedEmployee.socialSecurityNumber = formatNIR(event.target.value);
			this.ssnError = null;
		},

		showEditUserModal(employee) {
			this.selectedEmployee = employee;
			this.ssnError = null;

			// Afficher le numéro formaté avec espaces (stocké normalisé côté API)
			if (employee.socialSecurityNumber)
				employee.socialSecurityNumber = formatNIR(employee.socialSecurityNumber);

			this.$nextTick(() => {
					const modalElement = document.getElementById("editUser");
					let modal = window.bootstrap?.Modal?.getInstance(modalElement);

					if (!modal) {
							modal = new window.bootstrap.Modal(modalElement);
					}

					modal.show();

					modalElement.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
						if (!Tooltip.getInstance(el))
							new Tooltip(el)
					})
			});
		},

		async saveEmployeeProfile() {
			if (!this.selectedEmployee)
				return;

			if (this.selectedEmployee.socialSecurityNumber && !isValidNIR(this.selectedEmployee.socialSecurityNumber)) {
				this.ssnError = this.$t('validation.invalidSocialSecurityNumber');
				return;
			}

			this.ssnError = null;

			try {
				await HTTP.put(`/company/employees/${this.selectedEmployee._id}`, {
					firstName: this.selectedEmployee.firstName,
					lastName: this.selectedEmployee.lastName,
					email: this.selectedEmployee.email,
					entityName: this.selectedEmployee.entityName || null,
					socialSecurityNumber: this.selectedEmployee.socialSecurityNumber
						? normalizeNIR(this.selectedEmployee.socialSecurityNumber)
						: null,
				});

				this.selectedEmployeeUpdated = true;

				// Hide modal
				setTimeout(() => {
					const modal = window.bootstrap.Modal.getInstance(document.getElementById("editUser"));
					if (modal) {
						modal.hide();
					}
					this.selectedEmployeeUpdated = false;
				}, 1500)
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async deleteEmployee(employeeId) {
			if (!confirm(this.$t('confirm.deleteAccount')))
				return;

			try {
				await HTTP.delete("/company/employees/" + employeeId);
				this.fetchEmployees();
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployees() {
			try {
				const params = {
					page: this.pagination.page,
					limit: this.pagination.limit,
					search: this.search || undefined,
				};

				// Appel API avec les filtres et pagination
				const response = await HTTP.get("/company/employees", { params });

				// Mise à jour des données
				this.employees = response.data.employees;

				this.pagination.totalEntries = response.data.pagination.totalEntries;
				this.pagination.totalPages = response.data.pagination.totalPages;

				this.$nextTick(() => {
					const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
					tooltipTriggerList.forEach((el) => {
						if (!Tooltip.getInstance(el))
							new Tooltip(el)
					})
				})
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		generateInitials(employee) {
			if (!employee) return '';

			const firstInitial = employee.firstName ? employee.firstName.trim().charAt(0).toUpperCase() : '';
			const lastInitial = employee.lastName ? employee.lastName.trim().charAt(0).toUpperCase() : '';

			return `${firstInitial}${lastInitial}`;
		},

		// Méthode pour mettre à jour la page et relancer la recherche
		changePage(newPage) {
			if (newPage > 0 && newPage <= this.pagination.totalPages) {
				this.pagination.page = newPage;
				this.fetchEmployees(); // Charge les nouvelles données
			}
		},
		// Méthode déclenchée par les inputs de recherche
		applyFilters() {
			this.pagination.page = 1; // Réinitialiser à la première page
			this.fetchEmployees();
		},
		async fetchFeatureFlags() {
			try {
				const response = await HTTP.get('/company/flags');
				this.displayEntityName = response.data.displayEntityName;
			} catch (error) {
				console.error("Erreur API:", error);
			}
		},
	},

	async mounted() {
		await this.fetchEmployees();
		this.fetchFeatureFlags();

		const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
		tooltipTriggerList.forEach((el) => {
			new Tooltip(el)
		})
	}
};
</script>

<style scoped>
.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 250px;
	margin-bottom: 0px;
}

/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
